import { h$1 as me, h as xt, a as Et, Y as ge } from "./register-Ba9sFUKZ.js";
import { d as ye } from "./query-DoAo5UXi.js";
import { c as It, d as we, f as ve, h as be } from "./lifecycle-decorators-C04d1yHY.js";
import { t as xe } from "./uid-DGLBmjXH.js";
const Y = Math.min, I = Math.max, st = Math.round, lt = Math.floor, D = (t) => ({
  x: t,
  y: t
}), Ee = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, Te = {
  start: "end",
  end: "start"
};
function kt(t, e, n) {
  return I(t, Y(e, n));
}
function nt(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function V(t) {
  return t.split("-")[0];
}
function ot(t) {
  return t.split("-")[1];
}
function Kt(t) {
  return t === "x" ? "y" : "x";
}
function Mt(t) {
  return t === "y" ? "height" : "width";
}
function mt(t) {
  return ["top", "bottom"].includes(V(t)) ? "y" : "x";
}
function Ht(t) {
  return Kt(mt(t));
}
function Se(t, e, n) {
  n === void 0 && (n = !1);
  const o = ot(t), r = Ht(t), l = Mt(r);
  let a = r === "x" ? o === (n ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return e.reference[l] > e.floating[l] && (a = ct(a)), [a, ct(a)];
}
function $e(t) {
  const e = ct(t);
  return [Pt(t), e, Pt(e)];
}
function Pt(t) {
  return t.replace(/start|end/g, (e) => Te[e]);
}
function Le(t, e, n) {
  const o = ["left", "right"], r = ["right", "left"], l = ["top", "bottom"], a = ["bottom", "top"];
  switch (t) {
    case "top":
    case "bottom":
      return n ? e ? r : o : e ? o : r;
    case "left":
    case "right":
      return e ? l : a;
    default:
      return [];
  }
}
function Ae(t, e, n, o) {
  const r = ot(t);
  let l = Le(V(t), n === "start", o);
  return r && (l = l.map((a) => a + "-" + r), e && (l = l.concat(l.map(Pt)))), l;
}
function ct(t) {
  return t.replace(/left|right|bottom|top/g, (e) => Ee[e]);
}
function Re(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function Qt(t) {
  return typeof t != "number" ? Re(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function ut(t) {
  const {
    x: e,
    y: n,
    width: o,
    height: r
  } = t;
  return {
    width: o,
    height: r,
    top: n,
    left: e,
    right: e + o,
    bottom: n + r,
    x: e,
    y: n
  };
}
function jt(t, e, n) {
  let {
    reference: o,
    floating: r
  } = t;
  const l = mt(e), a = Ht(e), i = Mt(a), s = V(e), c = l === "y", f = o.x + o.width / 2 - r.width / 2, p = o.y + o.height / 2 - r.height / 2, d = o[i] / 2 - r[i] / 2;
  let u;
  switch (s) {
    case "top":
      u = {
        x: f,
        y: o.y - r.height
      };
      break;
    case "bottom":
      u = {
        x: f,
        y: o.y + o.height
      };
      break;
    case "right":
      u = {
        x: o.x + o.width,
        y: p
      };
      break;
    case "left":
      u = {
        x: o.x - r.width,
        y: p
      };
      break;
    default:
      u = {
        x: o.x,
        y: o.y
      };
  }
  switch (ot(e)) {
    case "start":
      u[a] -= d * (n && c ? -1 : 1);
      break;
    case "end":
      u[a] += d * (n && c ? -1 : 1);
      break;
  }
  return u;
}
const ke = async (t, e, n) => {
  const {
    placement: o = "bottom",
    strategy: r = "absolute",
    middleware: l = [],
    platform: a
  } = n, i = l.filter(Boolean), s = await (a.isRTL == null ? void 0 : a.isRTL(e));
  let c = await a.getElementRects({
    reference: t,
    floating: e,
    strategy: r
  }), {
    x: f,
    y: p
  } = jt(c, o, s), d = o, u = {}, h = 0;
  for (let m = 0; m < i.length; m++) {
    const {
      name: g,
      fn: y
    } = i[m], {
      x: w,
      y: v,
      data: b,
      reset: x
    } = await y({
      x: f,
      y: p,
      initialPlacement: o,
      placement: d,
      strategy: r,
      middlewareData: u,
      rects: c,
      platform: a,
      elements: {
        reference: t,
        floating: e
      }
    });
    f = w != null ? w : f, p = v != null ? v : p, u = {
      ...u,
      [g]: {
        ...u[g],
        ...b
      }
    }, x && h <= 50 && (h++, typeof x == "object" && (x.placement && (d = x.placement), x.rects && (c = x.rects === !0 ? await a.getElementRects({
      reference: t,
      floating: e,
      strategy: r
    }) : x.rects), {
      x: f,
      y: p
    } = jt(c, d, s)), m = -1);
  }
  return {
    x: f,
    y: p,
    placement: d,
    strategy: r,
    middlewareData: u
  };
};
async function te(t, e) {
  var n;
  e === void 0 && (e = {});
  const {
    x: o,
    y: r,
    platform: l,
    rects: a,
    elements: i,
    strategy: s
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: f = "viewport",
    elementContext: p = "floating",
    altBoundary: d = !1,
    padding: u = 0
  } = nt(e, t), h = Qt(u), m = i[d ? p === "floating" ? "reference" : "floating" : p], g = ut(await l.getClippingRect({
    element: (n = await (l.isElement == null ? void 0 : l.isElement(m))) == null || n ? m : m.contextElement || await (l.getDocumentElement == null ? void 0 : l.getDocumentElement(i.floating)),
    boundary: c,
    rootBoundary: f,
    strategy: s
  })), y = p === "floating" ? {
    x: o,
    y: r,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, w = await (l.getOffsetParent == null ? void 0 : l.getOffsetParent(i.floating)), v = await (l.isElement == null ? void 0 : l.isElement(w)) ? await (l.getScale == null ? void 0 : l.getScale(w)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, b = ut(l.convertOffsetParentRelativeRectToViewportRelativeRect ? await l.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: i,
    rect: y,
    offsetParent: w,
    strategy: s
  }) : y);
  return {
    top: (g.top - b.top + h.top) / v.y,
    bottom: (b.bottom - g.bottom + h.bottom) / v.y,
    left: (g.left - b.left + h.left) / v.x,
    right: (b.right - g.right + h.right) / v.x
  };
}
const Pe = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: n,
      y: o,
      placement: r,
      rects: l,
      platform: a,
      elements: i,
      middlewareData: s
    } = e, {
      element: c,
      padding: f = 0
    } = nt(t, e) || {};
    if (c == null)
      return {};
    const p = Qt(f), d = {
      x: n,
      y: o
    }, u = Ht(r), h = Mt(u), m = await a.getDimensions(c), g = u === "y", y = g ? "top" : "left", w = g ? "bottom" : "right", v = g ? "clientHeight" : "clientWidth", b = l.reference[h] + l.reference[u] - d[u] - l.floating[h], x = d[u] - l.reference[u], S = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(c));
    let k = S ? S[v] : 0;
    (!k || !await (a.isElement == null ? void 0 : a.isElement(S))) && (k = i.floating[v] || l.floating[h]);
    const B = b / 2 - x / 2, Z = k / 2 - m[h] / 2 - 1, J = Y(p[y], Z), K = Y(p[w], Z), $ = J, Q = k - m[h] - K, E = k / 2 - m[h] / 2 + B, P = kt($, E, Q), O = !s.arrow && ot(r) != null && E !== P && l.reference[h] / 2 - (E < $ ? J : K) - m[h] / 2 < 0, C = O ? E < $ ? E - $ : E - Q : 0;
    return {
      [u]: d[u] + C,
      data: {
        [u]: P,
        centerOffset: E - P - C,
        ...O && {
          alignmentOffset: C
        }
      },
      reset: O
    };
  }
}), Oe = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var n, o;
      const {
        placement: r,
        middlewareData: l,
        rects: a,
        initialPlacement: i,
        platform: s,
        elements: c
      } = e, {
        mainAxis: f = !0,
        crossAxis: p = !0,
        fallbackPlacements: d,
        fallbackStrategy: u = "bestFit",
        fallbackAxisSideDirection: h = "none",
        flipAlignment: m = !0,
        ...g
      } = nt(t, e);
      if ((n = l.arrow) != null && n.alignmentOffset)
        return {};
      const y = V(r), w = V(i) === i, v = await (s.isRTL == null ? void 0 : s.isRTL(c.floating)), b = d || (w || !m ? [ct(i)] : $e(i));
      !d && h !== "none" && b.push(...Ae(i, m, h, v));
      const x = [i, ...b], S = await te(e, g), k = [];
      let B = ((o = l.flip) == null ? void 0 : o.overflows) || [];
      if (f && k.push(S[y]), p) {
        const $ = Se(r, a, v);
        k.push(S[$[0]], S[$[1]]);
      }
      if (B = [...B, {
        placement: r,
        overflows: k
      }], !k.every(($) => $ <= 0)) {
        var Z, J;
        const $ = (((Z = l.flip) == null ? void 0 : Z.index) || 0) + 1, Q = x[$];
        if (Q)
          return {
            data: {
              index: $,
              overflows: B
            },
            reset: {
              placement: Q
            }
          };
        let E = (J = B.filter((P) => P.overflows[0] <= 0).sort((P, O) => P.overflows[1] - O.overflows[1])[0]) == null ? void 0 : J.placement;
        if (!E)
          switch (u) {
            case "bestFit": {
              var K;
              const P = (K = B.map((O) => [O.placement, O.overflows.filter((C) => C > 0).reduce((C, he) => C + he, 0)]).sort((O, C) => O[1] - C[1])[0]) == null ? void 0 : K[0];
              P && (E = P);
              break;
            }
            case "initialPlacement":
              E = i;
              break;
          }
        if (r !== E)
          return {
            reset: {
              placement: E
            }
          };
      }
      return {};
    }
  };
};
async function De(t, e) {
  const {
    placement: n,
    platform: o,
    elements: r
  } = t, l = await (o.isRTL == null ? void 0 : o.isRTL(r.floating)), a = V(n), i = ot(n), s = mt(n) === "y", c = ["left", "top"].includes(a) ? -1 : 1, f = l && s ? -1 : 1, p = nt(e, t);
  let {
    mainAxis: d,
    crossAxis: u,
    alignmentAxis: h
  } = typeof p == "number" ? {
    mainAxis: p,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...p
  };
  return i && typeof h == "number" && (u = i === "end" ? h * -1 : h), s ? {
    x: u * f,
    y: d * c
  } : {
    x: d * c,
    y: u * f
  };
}
const Me = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var n, o;
      const {
        x: r,
        y: l,
        placement: a,
        middlewareData: i
      } = e, s = await De(e, t);
      return a === ((n = i.offset) == null ? void 0 : n.placement) && (o = i.arrow) != null && o.alignmentOffset ? {} : {
        x: r + s.x,
        y: l + s.y,
        data: {
          ...s,
          placement: a
        }
      };
    }
  };
}, He = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: n,
        y: o,
        placement: r
      } = e, {
        mainAxis: l = !0,
        crossAxis: a = !1,
        limiter: i = {
          fn: (g) => {
            let {
              x: y,
              y: w
            } = g;
            return {
              x: y,
              y: w
            };
          }
        },
        ...s
      } = nt(t, e), c = {
        x: n,
        y: o
      }, f = await te(e, s), p = mt(V(r)), d = Kt(p);
      let u = c[d], h = c[p];
      if (l) {
        const g = d === "y" ? "top" : "left", y = d === "y" ? "bottom" : "right", w = u + f[g], v = u - f[y];
        u = kt(w, u, v);
      }
      if (a) {
        const g = p === "y" ? "top" : "left", y = p === "y" ? "bottom" : "right", w = h + f[g], v = h - f[y];
        h = kt(w, h, v);
      }
      const m = i.fn({
        ...e,
        [d]: u,
        [p]: h
      });
      return {
        ...m,
        data: {
          x: m.x - n,
          y: m.y - o
        }
      };
    }
  };
};
function gt() {
  return typeof window < "u";
}
function U(t) {
  return ee(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function T(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function H(t) {
  var e;
  return (e = (ee(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function ee(t) {
  return gt() ? t instanceof Node || t instanceof T(t).Node : !1;
}
function A(t) {
  return gt() ? t instanceof Element || t instanceof T(t).Element : !1;
}
function M(t) {
  return gt() ? t instanceof HTMLElement || t instanceof T(t).HTMLElement : !1;
}
function Vt(t) {
  return !gt() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof T(t).ShadowRoot;
}
function rt(t) {
  const {
    overflow: e,
    overflowX: n,
    overflowY: o,
    display: r
  } = R(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + o + n) && !["inline", "contents"].includes(r);
}
function Ce(t) {
  return ["table", "td", "th"].includes(U(t));
}
function yt(t) {
  return [":popover-open", ":modal"].some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
function Ct(t) {
  const e = Wt(), n = A(t) ? R(t) : t;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => n[o] ? n[o] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !e && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !e && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (n.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (n.contain || "").includes(o));
}
function We(t) {
  let e = F(t);
  for (; M(e) && !X(e); ) {
    if (Ct(e))
      return e;
    if (yt(e))
      return null;
    e = F(e);
  }
  return null;
}
function Wt() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function X(t) {
  return ["html", "body", "#document"].includes(U(t));
}
function R(t) {
  return T(t).getComputedStyle(t);
}
function wt(t) {
  return A(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function F(t) {
  if (U(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    Vt(t) && t.host || // Fallback.
    H(t)
  );
  return Vt(e) ? e.host : e;
}
function ne(t) {
  const e = F(t);
  return X(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : M(e) && rt(e) ? e : ne(e);
}
function tt(t, e, n) {
  var o;
  e === void 0 && (e = []), n === void 0 && (n = !0);
  const r = ne(t), l = r === ((o = t.ownerDocument) == null ? void 0 : o.body), a = T(r);
  if (l) {
    const i = Ot(a);
    return e.concat(a, a.visualViewport || [], rt(r) ? r : [], i && n ? tt(i) : []);
  }
  return e.concat(r, tt(r, [], n));
}
function Ot(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function oe(t) {
  const e = R(t);
  let n = parseFloat(e.width) || 0, o = parseFloat(e.height) || 0;
  const r = M(t), l = r ? t.offsetWidth : n, a = r ? t.offsetHeight : o, i = st(n) !== l || st(o) !== a;
  return i && (n = l, o = a), {
    width: n,
    height: o,
    $: i
  };
}
function Ft(t) {
  return A(t) ? t : t.contextElement;
}
function _(t) {
  const e = Ft(t);
  if (!M(e))
    return D(1);
  const n = e.getBoundingClientRect(), {
    width: o,
    height: r,
    $: l
  } = oe(e);
  let a = (l ? st(n.width) : n.width) / o, i = (l ? st(n.height) : n.height) / r;
  return (!a || !Number.isFinite(a)) && (a = 1), (!i || !Number.isFinite(i)) && (i = 1), {
    x: a,
    y: i
  };
}
const Fe = /* @__PURE__ */ D(0);
function re(t) {
  const e = T(t);
  return !Wt() || !e.visualViewport ? Fe : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function Be(t, e, n) {
  return e === void 0 && (e = !1), !n || e && n !== T(t) ? !1 : e;
}
function q(t, e, n, o) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  const r = t.getBoundingClientRect(), l = Ft(t);
  let a = D(1);
  e && (o ? A(o) && (a = _(o)) : a = _(t));
  const i = Be(l, n, o) ? re(l) : D(0);
  let s = (r.left + i.x) / a.x, c = (r.top + i.y) / a.y, f = r.width / a.x, p = r.height / a.y;
  if (l) {
    const d = T(l), u = o && A(o) ? T(o) : o;
    let h = d, m = Ot(h);
    for (; m && o && u !== h; ) {
      const g = _(m), y = m.getBoundingClientRect(), w = R(m), v = y.left + (m.clientLeft + parseFloat(w.paddingLeft)) * g.x, b = y.top + (m.clientTop + parseFloat(w.paddingTop)) * g.y;
      s *= g.x, c *= g.y, f *= g.x, p *= g.y, s += v, c += b, h = T(m), m = Ot(h);
    }
  }
  return ut({
    width: f,
    height: p,
    x: s,
    y: c
  });
}
function Bt(t, e) {
  const n = wt(t).scrollLeft;
  return e ? e.left + n : q(H(t)).left + n;
}
function ie(t, e, n) {
  n === void 0 && (n = !1);
  const o = t.getBoundingClientRect(), r = o.left + e.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    Bt(t, o)
  )), l = o.top + e.scrollTop;
  return {
    x: r,
    y: l
  };
}
function Ne(t) {
  let {
    elements: e,
    rect: n,
    offsetParent: o,
    strategy: r
  } = t;
  const l = r === "fixed", a = H(o), i = e ? yt(e.floating) : !1;
  if (o === a || i && l)
    return n;
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = D(1);
  const f = D(0), p = M(o);
  if ((p || !p && !l) && ((U(o) !== "body" || rt(a)) && (s = wt(o)), M(o))) {
    const u = q(o);
    c = _(o), f.x = u.x + o.clientLeft, f.y = u.y + o.clientTop;
  }
  const d = a && !p && !l ? ie(a, s, !0) : D(0);
  return {
    width: n.width * c.x,
    height: n.height * c.y,
    x: n.x * c.x - s.scrollLeft * c.x + f.x + d.x,
    y: n.y * c.y - s.scrollTop * c.y + f.y + d.y
  };
}
function Ie(t) {
  return Array.from(t.getClientRects());
}
function je(t) {
  const e = H(t), n = wt(t), o = t.ownerDocument.body, r = I(e.scrollWidth, e.clientWidth, o.scrollWidth, o.clientWidth), l = I(e.scrollHeight, e.clientHeight, o.scrollHeight, o.clientHeight);
  let a = -n.scrollLeft + Bt(t);
  const i = -n.scrollTop;
  return R(o).direction === "rtl" && (a += I(e.clientWidth, o.clientWidth) - r), {
    width: r,
    height: l,
    x: a,
    y: i
  };
}
function Ve(t, e) {
  const n = T(t), o = H(t), r = n.visualViewport;
  let l = o.clientWidth, a = o.clientHeight, i = 0, s = 0;
  if (r) {
    l = r.width, a = r.height;
    const c = Wt();
    (!c || c && e === "fixed") && (i = r.offsetLeft, s = r.offsetTop);
  }
  return {
    width: l,
    height: a,
    x: i,
    y: s
  };
}
function qe(t, e) {
  const n = q(t, !0, e === "fixed"), o = n.top + t.clientTop, r = n.left + t.clientLeft, l = M(t) ? _(t) : D(1), a = t.clientWidth * l.x, i = t.clientHeight * l.y, s = r * l.x, c = o * l.y;
  return {
    width: a,
    height: i,
    x: s,
    y: c
  };
}
function qt(t, e, n) {
  let o;
  if (e === "viewport")
    o = Ve(t, n);
  else if (e === "document")
    o = je(H(t));
  else if (A(e))
    o = qe(e, n);
  else {
    const r = re(t);
    o = {
      x: e.x - r.x,
      y: e.y - r.y,
      width: e.width,
      height: e.height
    };
  }
  return ut(o);
}
function le(t, e) {
  const n = F(t);
  return n === e || !A(n) || X(n) ? !1 : R(n).position === "fixed" || le(n, e);
}
function ze(t, e) {
  const n = e.get(t);
  if (n)
    return n;
  let o = tt(t, [], !1).filter((i) => A(i) && U(i) !== "body"), r = null;
  const l = R(t).position === "fixed";
  let a = l ? F(t) : t;
  for (; A(a) && !X(a); ) {
    const i = R(a), s = Ct(a);
    !s && i.position === "fixed" && (r = null), (l ? !s && !r : !s && i.position === "static" && r && ["absolute", "fixed"].includes(r.position) || rt(a) && !s && le(t, a)) ? o = o.filter((c) => c !== a) : r = i, a = F(a);
  }
  return e.set(t, o), o;
}
function _e(t) {
  let {
    element: e,
    boundary: n,
    rootBoundary: o,
    strategy: r
  } = t;
  const l = [...n === "clippingAncestors" ? yt(e) ? [] : ze(e, this._c) : [].concat(n), o], a = l[0], i = l.reduce((s, c) => {
    const f = qt(e, c, r);
    return s.top = I(f.top, s.top), s.right = Y(f.right, s.right), s.bottom = Y(f.bottom, s.bottom), s.left = I(f.left, s.left), s;
  }, qt(e, a, r));
  return {
    width: i.right - i.left,
    height: i.bottom - i.top,
    x: i.left,
    y: i.top
  };
}
function Ye(t) {
  const {
    width: e,
    height: n
  } = oe(t);
  return {
    width: e,
    height: n
  };
}
function Xe(t, e, n) {
  const o = M(e), r = H(e), l = n === "fixed", a = q(t, !0, l, e);
  let i = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const s = D(0);
  if (o || !o && !l)
    if ((U(e) !== "body" || rt(r)) && (i = wt(e)), o) {
      const d = q(e, !0, l, e);
      s.x = d.x + e.clientLeft, s.y = d.y + e.clientTop;
    } else r && (s.x = Bt(r));
  const c = r && !o && !l ? ie(r, i) : D(0), f = a.left + i.scrollLeft - s.x - c.x, p = a.top + i.scrollTop - s.y - c.y;
  return {
    x: f,
    y: p,
    width: a.width,
    height: a.height
  };
}
function Tt(t) {
  return R(t).position === "static";
}
function zt(t, e) {
  if (!M(t) || R(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let n = t.offsetParent;
  return H(t) === n && (n = n.ownerDocument.body), n;
}
function ae(t, e) {
  const n = T(t);
  if (yt(t))
    return n;
  if (!M(t)) {
    let r = F(t);
    for (; r && !X(r); ) {
      if (A(r) && !Tt(r))
        return r;
      r = F(r);
    }
    return n;
  }
  let o = zt(t, e);
  for (; o && Ce(o) && Tt(o); )
    o = zt(o, e);
  return o && X(o) && Tt(o) && !Ct(o) ? n : o || We(t) || n;
}
const Ge = async function(t) {
  const e = this.getOffsetParent || ae, n = this.getDimensions, o = await n(t.floating);
  return {
    reference: Xe(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function Ue(t) {
  return R(t).direction === "rtl";
}
const Ze = {
  convertOffsetParentRelativeRectToViewportRelativeRect: Ne,
  getDocumentElement: H,
  getClippingRect: _e,
  getOffsetParent: ae,
  getElementRects: Ge,
  getClientRects: Ie,
  getDimensions: Ye,
  getScale: _,
  isElement: A,
  isRTL: Ue
};
function se(t, e) {
  return t.x === e.x && t.y === e.y && t.width === e.width && t.height === e.height;
}
function Je(t, e) {
  let n = null, o;
  const r = H(t);
  function l() {
    var i;
    clearTimeout(o), (i = n) == null || i.disconnect(), n = null;
  }
  function a(i, s) {
    i === void 0 && (i = !1), s === void 0 && (s = 1), l();
    const c = t.getBoundingClientRect(), {
      left: f,
      top: p,
      width: d,
      height: u
    } = c;
    if (i || e(), !d || !u)
      return;
    const h = lt(p), m = lt(r.clientWidth - (f + d)), g = lt(r.clientHeight - (p + u)), y = lt(f), w = {
      rootMargin: -h + "px " + -m + "px " + -g + "px " + -y + "px",
      threshold: I(0, Y(1, s)) || 1
    };
    let v = !0;
    function b(x) {
      const S = x[0].intersectionRatio;
      if (S !== s) {
        if (!v)
          return a();
        S ? a(!1, S) : o = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      S === 1 && !se(c, t.getBoundingClientRect()) && a(), v = !1;
    }
    try {
      n = new IntersectionObserver(b, {
        ...w,
        // Handle <iframe>s
        root: r.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(b, w);
    }
    n.observe(t);
  }
  return a(!0), l;
}
function Ke(t, e, n, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: r = !0,
    ancestorResize: l = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: i = typeof IntersectionObserver == "function",
    animationFrame: s = !1
  } = o, c = Ft(t), f = r || l ? [...c ? tt(c) : [], ...tt(e)] : [];
  f.forEach((y) => {
    r && y.addEventListener("scroll", n, {
      passive: !0
    }), l && y.addEventListener("resize", n);
  });
  const p = c && i ? Je(c, n) : null;
  let d = -1, u = null;
  a && (u = new ResizeObserver((y) => {
    let [w] = y;
    w && w.target === c && u && (u.unobserve(e), cancelAnimationFrame(d), d = requestAnimationFrame(() => {
      var v;
      (v = u) == null || v.observe(e);
    })), n();
  }), c && !s && u.observe(c), u.observe(e));
  let h, m = s ? q(t) : null;
  s && g();
  function g() {
    const y = q(t);
    m && !se(m, y) && n(), m = y, h = requestAnimationFrame(g);
  }
  return n(), () => {
    var y;
    f.forEach((w) => {
      r && w.removeEventListener("scroll", n), l && w.removeEventListener("resize", n);
    }), p == null || p(), (y = u) == null || y.disconnect(), u = null, s && cancelAnimationFrame(h);
  };
}
const Qe = Me, tn = He, en = Oe, nn = Pe, on = (t, e, n) => {
  const o = /* @__PURE__ */ new Map(), r = {
    platform: Ze,
    ...n
  }, l = {
    ...r.platform,
    _c: o
  };
  return ke(t, e, {
    ...r,
    platform: l
  });
};
var rn = Object.defineProperty, ln = (t, e, n) => e in t ? rn(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, _t = (t, e, n) => ln(t, typeof e != "symbol" ? e + "" : e, n), vt = class extends Event {
  constructor(t, { oldState: e = "", newState: n = "", ...o } = {}) {
    super(t, o), _t(this, "oldState"), _t(this, "newState"), this.oldState = String(e || ""), this.newState = String(n || "");
  }
}, Yt = /* @__PURE__ */ new WeakMap();
function ce(t, e, n) {
  Yt.set(
    t,
    setTimeout(() => {
      Yt.has(t) && t.dispatchEvent(
        new vt("toggle", {
          cancelable: !1,
          oldState: e,
          newState: n
        })
      );
    }, 0)
  );
}
var Nt = globalThis.ShadowRoot || function() {
}, an = globalThis.HTMLDialogElement || function() {
}, at = /* @__PURE__ */ new WeakMap(), W = /* @__PURE__ */ new WeakMap(), it = /* @__PURE__ */ new WeakMap();
function ft(t) {
  return it.get(t) || "hidden";
}
var pt = /* @__PURE__ */ new WeakMap();
function sn(t) {
  const e = t.popoverTargetElement;
  if (!(e instanceof HTMLElement))
    return;
  const n = ft(e);
  t.popoverTargetAction === "show" && n === "showing" || t.popoverTargetAction === "hide" && n === "hidden" || (n === "showing" ? et(e, !0, !0) : j(e, !1) && (pt.set(e, t), Dt(e)));
}
function j(t, e) {
  return !(t.popover !== "auto" && t.popover !== "manual" || !t.isConnected || e && ft(t) !== "showing" || !e && ft(t) !== "hidden" || t instanceof an && t.hasAttribute("open") || document.fullscreenElement === t);
}
function Xt(t) {
  return t ? Array.from(W.get(t.ownerDocument) || []).indexOf(
    t
  ) + 1 : 0;
}
function cn(t) {
  const e = ue(t), n = un(t);
  return Xt(e) > Xt(n) ? e : n;
}
function dt(t) {
  const e = W.get(t);
  for (const n of e || [])
    if (!n.isConnected)
      e.delete(n);
    else
      return n;
  return null;
}
function G(t) {
  return typeof t.getRootNode == "function" ? t.getRootNode() : t.parentNode ? G(t.parentNode) : t;
}
function ue(t) {
  for (; t; ) {
    if (t instanceof HTMLElement && t.popover === "auto" && it.get(t) === "showing")
      return t;
    if (t = t instanceof Element && t.assignedSlot || t.parentElement || G(t), t instanceof Nt && (t = t.host), t instanceof Document) return;
  }
}
function un(t) {
  for (; t; ) {
    const e = t.popoverTargetElement;
    if (e instanceof HTMLElement) return e;
    if (t = t.parentElement || G(t), t instanceof Nt && (t = t.host), t instanceof Document) return;
  }
}
function fn(t) {
  const e = /* @__PURE__ */ new Map();
  let n = 0;
  for (const l of W.get(t.ownerDocument) || [])
    e.set(l, n), n += 1;
  e.set(t, n), n += 1;
  let o = null;
  function r(l) {
    const a = ue(l);
    if (a === null) return null;
    const i = e.get(a);
    (o === null || e.get(o) < i) && (o = a);
  }
  return r(t.parentElement || G(t)), o;
}
function pn(t) {
  return t.hidden || t instanceof Nt || (t instanceof HTMLButtonElement || t instanceof HTMLInputElement || t instanceof HTMLSelectElement || t instanceof HTMLTextAreaElement || t instanceof HTMLOptGroupElement || t instanceof HTMLOptionElement || t instanceof HTMLFieldSetElement) && t.disabled || t instanceof HTMLInputElement && t.type === "hidden" || t instanceof HTMLAnchorElement && t.href === "" ? !1 : typeof t.tabIndex == "number" && t.tabIndex !== -1;
}
function dn(t) {
  if (t.shadowRoot && t.shadowRoot.delegatesFocus !== !0)
    return null;
  let e = t;
  e.shadowRoot && (e = e.shadowRoot);
  let n = e.querySelector("[autofocus]");
  if (n)
    return n;
  {
    const l = e.querySelectorAll("slot");
    for (const a of l) {
      const i = a.assignedElements({ flatten: !0 });
      for (const s of i) {
        if (s.hasAttribute("autofocus"))
          return s;
        if (n = s.querySelector("[autofocus]"), n)
          return n;
      }
    }
  }
  const o = t.ownerDocument.createTreeWalker(
    e,
    NodeFilter.SHOW_ELEMENT
  );
  let r = o.currentNode;
  for (; r; ) {
    if (pn(r))
      return r;
    r = o.nextNode();
  }
}
function hn(t) {
  var e;
  (e = dn(t)) == null || e.focus();
}
var ht = /* @__PURE__ */ new WeakMap();
function Dt(t) {
  if (!j(t, !1))
    return;
  const e = t.ownerDocument;
  if (!t.dispatchEvent(
    new vt("beforetoggle", {
      cancelable: !0,
      oldState: "closed",
      newState: "open"
    })
  ) || !j(t, !1))
    return;
  let n = !1;
  if (t.popover === "auto") {
    const r = t.getAttribute("popover"), l = fn(t) || e;
    if (bt(l, !1, !0), r !== t.getAttribute("popover") || !j(t, !1))
      return;
  }
  dt(e) || (n = !0), ht.delete(t);
  const o = e.activeElement;
  t.classList.add(":popover-open"), it.set(t, "showing"), at.has(e) || at.set(e, /* @__PURE__ */ new Set()), at.get(e).add(t), hn(t), t.popover === "auto" && (W.has(e) || W.set(e, /* @__PURE__ */ new Set()), W.get(e).add(t), fe(pt.get(t), !0)), n && o && t.popover === "auto" && ht.set(t, o), ce(t, "closed", "open");
}
function et(t, e = !1, n = !1) {
  var o, r;
  if (!j(t, !0))
    return;
  const l = t.ownerDocument;
  if (t.popover === "auto" && (bt(t, e, n), !j(t, !0)) || (fe(pt.get(t), !1), pt.delete(t), n && (t.dispatchEvent(
    new vt("beforetoggle", {
      oldState: "open",
      newState: "closed"
    })
  ), !j(t, !0))))
    return;
  (o = at.get(l)) == null || o.delete(t), (r = W.get(l)) == null || r.delete(t), t.classList.remove(":popover-open"), it.set(t, "hidden"), n && ce(t, "open", "closed");
  const a = ht.get(t);
  a && (ht.delete(t), e && a.focus());
}
function Gt(t, e = !1, n = !1) {
  let o = dt(t);
  for (; o; )
    et(o, e, n), o = dt(t);
}
function bt(t, e, n) {
  var o;
  const r = t.ownerDocument || t;
  if (t instanceof Document)
    return Gt(r, e, n);
  let l = null, a = !1;
  for (const i of W.get(r) || [])
    if (i === t)
      a = !0;
    else if (a) {
      l = i;
      break;
    }
  if (!a)
    return Gt(r, e, n);
  for (; l && ft(l) === "showing" && (o = W.get(r)) != null && o.size; )
    et(l, e, n);
}
var St = /* @__PURE__ */ new WeakMap();
function Ut(t) {
  if (!t.isTrusted) return;
  const e = t.composedPath()[0];
  if (!e) return;
  const n = e.ownerDocument;
  if (!dt(n)) return;
  const o = cn(e);
  if (o && t.type === "pointerdown")
    St.set(n, o);
  else if (t.type === "pointerup") {
    const r = St.get(n) === o;
    St.delete(n), r && bt(o || n, !1, !0);
  }
}
var $t = /* @__PURE__ */ new WeakMap();
function fe(t, e = !1) {
  if (!t) return;
  $t.has(t) || $t.set(t, t.getAttribute("aria-expanded"));
  const n = t.popoverTargetElement;
  if (n instanceof HTMLElement && n.popover === "auto")
    t.setAttribute("aria-expanded", String(e));
  else {
    const o = $t.get(t);
    o ? t.setAttribute("aria-expanded", o) : t.removeAttribute("aria-expanded");
  }
}
var Zt = globalThis.ShadowRoot || function() {
};
function mn() {
  return typeof HTMLElement < "u" && typeof HTMLElement.prototype == "object" && "popover" in HTMLElement.prototype;
}
function N(t, e, n) {
  const o = t[e];
  Object.defineProperty(t, e, {
    value(r) {
      return o.call(this, n(r));
    }
  });
}
var gn = /(^|[^\\]):popover-open\b/g;
function yn() {
  return typeof globalThis.CSSLayerBlockRule == "function";
}
function wn() {
  const t = yn();
  return `
${t ? "@layer popover-polyfill {" : ""}
  :where([popover]) {
    position: fixed;
    z-index: 2147483647;
    inset: 0;
    padding: 0.25em;
    width: fit-content;
    height: fit-content;
    border-width: initial;
    border-color: initial;
    border-image: initial;
    border-style: solid;
    background-color: canvas;
    color: canvastext;
    overflow: auto;
    margin: auto;
  }

  :where([popover]:not(.\\:popover-open)) {
    display: none;
  }

  :where(dialog[popover].\\:popover-open) {
    display: block;
  }

  :where(dialog[popover][open]) {
    display: revert;
  }

  :where([anchor].\\:popover-open) {
    inset: auto;
  }

  :where([anchor]:popover-open) {
    inset: auto;
  }

  @supports not (background-color: canvas) {
    :where([popover]) {
      background-color: white;
      color: black;
    }
  }

  @supports (width: -moz-fit-content) {
    :where([popover]) {
      width: -moz-fit-content;
      height: -moz-fit-content;
    }
  }

  @supports not (inset: 0) {
    :where([popover]) {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
    }
  }
${t ? "}" : ""}
`;
}
var z = null;
function Lt(t) {
  const e = wn();
  if (z === null)
    try {
      z = new CSSStyleSheet(), z.replaceSync(e);
    } catch {
      z = !1;
    }
  if (z === !1) {
    const n = document.createElement("style");
    n.textContent = e, t instanceof Document ? t.head.prepend(n) : t.prepend(n);
  } else
    t.adoptedStyleSheets = [z, ...t.adoptedStyleSheets];
}
function vn() {
  if (typeof window > "u") return;
  window.ToggleEvent = window.ToggleEvent || vt;
  function t(i) {
    return i != null && i.includes(":popover-open") && (i = i.replace(
      gn,
      "$1.\\:popover-open"
    )), i;
  }
  N(Document.prototype, "querySelector", t), N(Document.prototype, "querySelectorAll", t), N(Element.prototype, "querySelector", t), N(Element.prototype, "querySelectorAll", t), N(Element.prototype, "matches", t), N(Element.prototype, "closest", t), N(
    DocumentFragment.prototype,
    "querySelectorAll",
    t
  ), Object.defineProperties(HTMLElement.prototype, {
    popover: {
      enumerable: !0,
      configurable: !0,
      get() {
        if (!this.hasAttribute("popover")) return null;
        const i = (this.getAttribute("popover") || "").toLowerCase();
        return i === "" || i == "auto" ? "auto" : "manual";
      },
      set(i) {
        i === null ? this.removeAttribute("popover") : this.setAttribute("popover", i);
      }
    },
    showPopover: {
      enumerable: !0,
      configurable: !0,
      value() {
        Dt(this);
      }
    },
    hidePopover: {
      enumerable: !0,
      configurable: !0,
      value() {
        et(this, !0, !0);
      }
    },
    togglePopover: {
      enumerable: !0,
      configurable: !0,
      value(i) {
        it.get(this) === "showing" && i === void 0 || i === !1 ? et(this, !0, !0) : (i === void 0 || i === !0) && Dt(this);
      }
    }
  });
  const e = Element.prototype.attachShadow;
  e && Object.defineProperties(Element.prototype, {
    attachShadow: {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value(i) {
        const s = e.call(this, i);
        return Lt(s), s;
      }
    }
  });
  const n = HTMLElement.prototype.attachInternals;
  n && Object.defineProperties(HTMLElement.prototype, {
    attachInternals: {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value() {
        const i = n.call(this);
        return i.shadowRoot && Lt(i.shadowRoot), i;
      }
    }
  });
  const o = /* @__PURE__ */ new WeakMap();
  function r(i) {
    Object.defineProperties(i.prototype, {
      popoverTargetElement: {
        enumerable: !0,
        configurable: !0,
        set(s) {
          if (s === null)
            this.removeAttribute("popovertarget"), o.delete(this);
          else if (s instanceof Element)
            this.setAttribute("popovertarget", ""), o.set(this, s);
          else
            throw new TypeError(
              "popoverTargetElement must be an element or null"
            );
        },
        get() {
          if (this.localName !== "button" && this.localName !== "input" || this.localName === "input" && this.type !== "reset" && this.type !== "image" && this.type !== "button" || this.disabled || this.form && this.type === "submit")
            return null;
          const s = o.get(this);
          if (s && s.isConnected)
            return s;
          if (s && !s.isConnected)
            return o.delete(this), null;
          const c = G(this), f = this.getAttribute("popovertarget");
          return (c instanceof Document || c instanceof Zt) && f && c.getElementById(f) || null;
        }
      },
      popoverTargetAction: {
        enumerable: !0,
        configurable: !0,
        get() {
          const s = (this.getAttribute("popovertargetaction") || "").toLowerCase();
          return s === "show" || s === "hide" ? s : "toggle";
        },
        set(s) {
          this.setAttribute("popovertargetaction", s);
        }
      }
    });
  }
  r(HTMLButtonElement), r(HTMLInputElement);
  const l = (i) => {
    const s = i.composedPath(), c = s[0];
    if (!(c instanceof Element) || c != null && c.shadowRoot)
      return;
    const f = G(c);
    if (!(f instanceof Zt || f instanceof Document))
      return;
    const p = s.find(
      (d) => {
        var u;
        return (u = d.matches) == null ? void 0 : u.call(d, "[popovertargetaction],[popovertarget]");
      }
    );
    if (p) {
      sn(p), i.preventDefault();
      return;
    }
  }, a = (i) => {
    const s = i.key, c = i.target;
    !i.defaultPrevented && c && (s === "Escape" || s === "Esc") && bt(c.ownerDocument, !0, !0);
  };
  ((i) => {
    i.addEventListener("click", l), i.addEventListener("keydown", a), i.addEventListener("pointerdown", Ut), i.addEventListener("pointerup", Ut);
  })(document), Lt(document);
}
const bn = me`:host{background-color:var(--beacon-system-color-background-1);border:0;border-radius:var(--beacon-system-radius-corner-standard);color:var(--beacon-system-color-text-standard);display:revert;inset:unset;margin:unset;overflow:unset;padding:var(--beacon-system-space-cell-contained);position:absolute}.arrow{position:absolute}`;
var xn = Object.defineProperty, En = Object.getOwnPropertyDescriptor, pe = (t) => {
  throw TypeError(t);
}, L = (t, e, n, o) => {
  for (var r = o > 1 ? void 0 : o ? En(e, n) : e, l = t.length - 1, a; l >= 0; l--)
    (a = t[l]) && (r = (o ? a(e, n, r) : a(r)) || r);
  return o && r && xn(e, n, r), r;
}, de = (t, e, n) => e.has(t) || pe("Cannot " + n), At = (t, e, n) => (de(t, e, "read from private field"), n ? n.call(t) : e.get(t)), Jt = (t, e, n) => e.has(t) ? pe("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), Rt = (t, e, n, o) => (de(t, e, "write to private field"), e.set(t, n), n);
function An(t) {
  var e, n;
  let o = class extends t {
    constructor() {
      super(...arguments), Jt(this, e), this.popover = "manual", this.placement = "top", this.fallbackPlacements = void 0, this.arrowPadding = void 0, Jt(this, n, !1), this.show = (r) => {
        this.showCallback(r);
      }, this.showCallback = (r) => {
        this.open = !0, this.handleInteractionEvent(r), this.start();
      }, this.hide = (r) => {
        this.hideCallback(r);
      }, this.hideCallback = (r) => {
        this.open = !1, this.handleInteractionEvent(r), this.stop();
      }, this.toggle = (r) => {
        this.open ? this.hide(r) : this.show(r), this.handleInteractionEvent(r);
      }, this.closeOnEscape = (r) => {
        r.key === "Escape" && this.open && this.hide(r);
      };
    }
    static get popupStyles() {
      return [bn];
    }
    get open() {
      return At(this, n);
    }
    set open(r) {
      Rt(this, n, r), this.open ? this.showPopover() : this.hidePopover();
    }
    // The use of the event for setting the active trigger is why popups differ from modal in that you need to call show, hide, or toggle directly over the open prop
    handleInteractionEvent(r) {
      if (r) {
        const { target: l } = r;
        l instanceof HTMLElement && (this._activeTrigger = l);
      }
    }
    start() {
      this._activeTrigger && (Rt(this, e, Ke(
        this._activeTrigger,
        this,
        () => this.position()
      )), this.runOnStart());
    }
    stop() {
      At(this, e) && (At(this, e).call(this), Rt(this, e, null)), this.runOnStop();
    }
    /** @abstract */
    runOnStart() {
    }
    /** @abstract */
    runOnStop() {
    }
    getOffset(r) {
      return r.offsetHeight / 2;
    }
    getStaticSideArrowOffset(r, l) {
      return `-${r.offsetWidth}px`;
    }
    /**
     * @link https://codesandbox.io/s/mystifying-kare-ee3hmh?file=/src/index.js - examples of arrow positioning
     */
    position() {
      const r = this.arrow;
      on(this._activeTrigger, this, {
        placement: this.placement,
        middleware: [
          Qe(this.getOffset(r)),
          // fallback to the starting position of each axis first when flipping
          en({
            fallbackAxisSideDirection: "start",
            fallbackPlacements: this.fallbackPlacements
          }),
          // specifying a padding will allow it to move with your screen the specified distance before it flips
          tn({ padding: 8 }),
          // Optional Arrow Padding override for the menu-popover to align with internal padding;
          nn({
            element: r,
            padding: this.arrowPadding ? parseInt(this.arrowPadding) : void 0
          })
        ]
      }).then(
        ({ x: l, y: a, middlewareData: i, placement: s }) => {
          Object.assign(this.style, {
            top: a + "px",
            left: l + "px"
          });
          const c = s.split("-")[0], f = {
            top: "bottom",
            right: "left",
            bottom: "top",
            left: "right"
          }[c];
          if (i.arrow) {
            const { x: p, y: d } = i.arrow;
            Object.assign(r.style, {
              left: p != null ? `${p}px` : "",
              top: d != null ? `${d}px` : "",
              [f]: this.getStaticSideArrowOffset(r, f)
            }), r == null || r.setAttribute("data-side", c);
          }
        }
      );
    }
    _renderArrowHTML() {
      return ge`<div class="arrow"></div>`;
    }
    /** We need an ID to associate the popup as the describing element for triggers that aren't Beacon buttons. */
    assignAutoID() {
      this.id || (this.id = xe());
    }
    applyPopoverPolyfill() {
      mn() || vn();
    }
    handleEscapeToHide() {
      window.addEventListener("keydown", this.closeOnEscape);
    }
    removeEscapeToHide() {
      window.removeEventListener("keydown", this.closeOnEscape);
    }
  };
  return e = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap(), L([
    xt({ reflect: !0 })
  ], o.prototype, "popover", 2), L([
    xt()
  ], o.prototype, "placement", 2), L([
    Et()
  ], o.prototype, "fallbackPlacements", 2), L([
    Et()
  ], o.prototype, "arrowPadding", 2), L([
    xt({ type: Boolean, reflect: !0 })
  ], o.prototype, "open", 1), L([
    Et()
  ], o.prototype, "_activeTrigger", 2), L([
    ye(".arrow")
  ], o.prototype, "arrow", 2), L([
    It
  ], o.prototype, "assignAutoID", 1), L([
    It
  ], o.prototype, "applyPopoverPolyfill", 1), L([
    we
  ], o.prototype, "handleEscapeToHide", 1), L([
    ve
  ], o.prototype, "removeEscapeToHide", 1), o = L([
    be("Popup")
  ], o), o;
}
export {
  An as R
};
